// this is an autogenerated file from App/Account/Content/Settings/Content/CalendarSettings/Settings/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_CalendarSettings_Settings_Content($location_id: uuid!) {
  calendar_location_settings(where: { location_id: { _eq: $location_id } }) {
    id
    location_id
    full_day_default
    patient_default
  }
}

`